import { isNil } from './isNil';

export const getFormattedAmount = (value: number | string | undefined): string => {
	return !isNil(value) ? `$${value!.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}` : '';
};
